export { default } from './FAQDetails'
